import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

import { analytics as analyticsData } from './data';
import { CalsoftMockApi } from 'src/app/global/mock-api/mock-api.interfaces';
import { CalsoftMockApiService } from 'src/app/global/mock-api/mock-api.service';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsMockApi implements CalsoftMockApi
{
    // Private
    private _analytics: any;

    /**
     * Constructor
     *
     * @param _calsoftMockApiService
     */
    constructor(
        private _calsoftMockApiService: CalsoftMockApiService
    )
    {
        // Set the data
        this._analytics = analyticsData;

        // Register the API endpoints
        this.register();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register
     */
    register(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._calsoftMockApiService
            .onGet('api/dashboards/analytics')
            .reply(() => {

                return [
                    200,
                    _.cloneDeep(this._analytics)
                ];
            });
    }
}
